import { css, html, LitElement } from 'lit-element';
import i18n from '@giswebgroup/ki-wcp-base/src/decorators/i18n';
import moment from 'moment';
import nls from '../../locales/index.nls';

export default
@i18n(nls)
class KiStationInfoAlarmstatus extends LitElement {
  static styles = css`
    :host {
      display: block;
    }
    .station-name {
      padding-right: 5px;
      padding-left: 10px;
      padding-top: 10px;
      font-size: 1.2em;
    }

    hr {
      margin: 5px 0;
    }
    .table {
      display: table;
      line-height: 1.5em;
    }
    .row {
      display: table-row;
    }
    .cell {
      display: table-cell;
      padding: 0 10px;
      min-width: 50px;
      color: gray;
    }
    .label {
      color: #4a4a49;
    }
  `;

  static get properties() {
    return {
      stations: { type: Array }, // can be one or more stations
    };
  }

  constructor() {
    super();
    this.stations = [];
    const formatter = new Intl.NumberFormat(this.i18n.language, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    this.valFormatter = {
      format(val) {
        return val === 0 ? val : formatter.format(val);
      },
    };
  }

  _stationTmpl(station) {
    const parameter = station.stationparameter_name;
    let dataprovider = station.ADMINISTRATEUR;
    if(station.site_no ==="DGH"){
      dataprovider = " SPW - MI"
    }else if(station.site_no ==="DCENN"){
      dataprovider = " SPW - ARNE"
    }
    return html`<div class="station-name">${station.station_no} | ${station.station_name} | ${station.river_name}</div>
      <hr />
      <div class="table">
        <div class="row">
          <div class="cell label">${this.i18n.t('alarm_status')}</div>
          <div class="cell">${station.__tag_label || '-'}</div>
        </div>
        <div class="row">
          <div class="cell label">${this.i18n.t(parameter)}</div>
          <div class="cell">${station.ts_value != null ? `${this.valFormatter.format(station.ts_value)} ${station.ts_unitsymbol}` : '-'}</div>
        </div>
        <div class="row">
          <div class="cell label">${this.i18n.t('last_measure')}</div>
          <div class="cell">${(station.timestamp && moment(station.timestamp).format('L LT')) || '-'}</div>
        </div>
        <div class="row">
          <div class="cell label">${this.i18n.t('dataProvider')}</div>
          <div class="cell">${dataprovider}</div>
        </div>
      </div>`;
  }

  render() {
    return html`${this.stations.map(station => this._stationTmpl(station))}`;
  }
}

customElements.define('ki-station-info-alarmstatus', KiStationInfoAlarmstatus);
